<template lang="pug">
    #app
        VueExtendLayouts(path="layouts")
</template>

<style lang="scss">
    @import "~@meinauto-gmbh/component-library/src/assets/scss/variables";
    @import "~@meinauto-gmbh/component-library/dist/main.css";
    @import "scss/base";
</style>

<script>
import VueExtendLayouts from "vue-extend-layout";

export default {
    name: "App",
    components: {VueExtendLayouts},
    metaInfo: {
        titleTemplate: "%s: Digitaler Bestellprozess - MeinAuto.de",
        meta: [
            { name: "description", content: "Mit dem digitalen Bestellprozess von MeinAuto.de in 3 einfachen Schritten und in wenigen Minuten zum unterschriebenen Vertrag für Ihren Neuwagen." },
            { name: "robots", content: "noindex, nofollow" }
        ]
    }
};
</script>
